import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const styles = theme => {
    const unit = theme.spacing();
    return {
        root: {
            display: 'flex',
            padding: `${unit * 2}px ${unit * 2}px 0 ${unit * 2}px`,
        },
        outside: {
            padding: `0 0 ${unit * 2}px `,
        },
        title: {
            flex: '1 1 auto',
        },
        info: {
            marin: `0 0 0 ${unit * 2}px`,
        },
    };
};

const PageHeader = ({
    title,
    subtitle,
    outside,
    children,
    classes,
    secondary,
}) => {
    const rootClassName = classNames(classes.root, {
        [classes.outside]: outside,
    });
    const subtileColor = outside || secondary ? 'textSecondary' : 'textPrimary';
    return title ? (
        <div className={rootClassName}>
            <div className={classes.title}>
                <Typography variant="h6">{title}</Typography>
                {subtitle && (
                    <Typography variant="body2" color={subtileColor}>
                        {subtitle}
                    </Typography>
                )}
            </div>
            {children && <div className={classes.info}>{children}</div>}
        </div>
    ) : null;
};

PageHeader.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    children: PropTypes.node,
    outside: PropTypes.bool,
};

export default withStyles(styles)(PageHeader);
